import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';
import { OptionalDate } from './type';

export const getDaysDifference = (date1: Date, date2: OptionalDate = null): number => {
  if (!date2) return differenceInDays(new Date(), date1);
  return differenceInDays(date1, date2);
};

export const getHoursDifference = (date1: Date, date2: OptionalDate = null): number => {
  if (!date2) return differenceInHours(new Date(), date1);
  return differenceInHours(date1, date2);
};

export const getMinutesDifference = (date1: Date, date2: OptionalDate = null): number => {
  if (!date2) return differenceInMinutes(new Date(), date1);
  return differenceInMinutes(date1, date2);
};

export const getTimeDifference = (
  date1: Date,
  date2: OptionalDate = null,
): { days: number; hours: number; minutes: number } => {
  const days = getDaysDifference(date1, date2);
  const hours = getHoursDifference(date1, date2) % 24;
  const minutes = getMinutesDifference(date1, date2) % 60;
  return { days, hours, minutes };
};
